import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';
import { DocumentVisa } from '../models/dcoument-visa.model';
import { BydModel } from '@sixense/byd-core-service';
import { DocumentVisaInterface } from '../interfaces/document-visa.interface';
import { SubmitValidationDataInterface } from '../interfaces/submit-validation-data.interface';
import { VisaDataModel } from '../models/visa-data.model';

@Injectable({
  providedIn: 'root',
})
export class VisasService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Get My visas to validate.
   *
   * @param projectId ProjectId.
   * @returns Visas.
   */
  public getMyVisasToValidate(projectId: number): Observable<BydModel<DocumentVisa[]>> {
    this.path = `/v1/bimdata/projects/${projectId}/me/visa/validator`;
    return this.getModels<DocumentVisa[]>();
  }

  /**
   * Submit visa response.
   *
   * @param projectId ProjectId.
   * @param validationData validation data.
   * @returns empty observable.
   */
  public submitVisa(projectId: number, validationData: SubmitValidationDataInterface): Observable<void> {
    this.path = `/v1/bimdata/projects/${projectId}/document/${validationData.documentId}/visa/${validationData.visaId}/validation/${validationData.validatorId}/response`;
    const formData = new FormData();
    const data = new VisaDataModel(validationData.visaData);
    if (data.state) formData.append('state', data.state);
    if (data.attachment) formData.append('attachment', data.attachment);
    if (data.comment) formData.append('comment', data.comment);
    const headers = this.bydConfigService.headers.delete('Content-Type');
    return this.post({ body: formData, headers });
  }

  /**
   * Delete a visa.
   *
   * @param projectId Project id.
   * @param documentId Document id.
   * @param visaId Visa id.
   * @returns Observable<void>
   */
  public deleteVisa(projectId: number, documentId: number, visaId: number): Observable<void> {
    this.path = `/v1/bimdata/admin/projects/${projectId}/document/${documentId}/visa/${visaId}`;
    return this.delete();
  }

  /**
   * Create DocumentVisa instance.
   *
   * @param  jsonObject The flat json object.
   * @returns an `DocumentVisa` instance.
   */
  public createNewInstance(jsonObject: DocumentVisaInterface): DocumentVisa {
    return new DocumentVisa(jsonObject);
  }
}
